document.addEventListener('DOMContentLoaded', function(){
    const newProductsSection = document.querySelector('.sj-new-products');
    const newProductsList = document.querySelector('.sj-new-products__list');
    if (!newProductsSection || !newProductsList) return;
    const collection = newProductsSection.dataset.collectionHandle;
    if(!collection) return;

    async function fetchCollectionProducts(handle){
        const limit = 250;
        let page = 1;
        let allProducts = [];
        let moreProducts = true;

        while(moreProducts && allProducts.length < 4){
            const response = await fetch (`/collections/${handle}/products.json?limit=${limit}&page=${page}`);
            if (!response.ok) break;
            const data = await response.json();
            if (!data.products || data.products.length === 0) break;
            for (const card_product of data.products) {
                const hasDiscount = card_product.variants.some(
                    variant => variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)
                );

                if (hasDiscount) {
                    allProducts.push(card_product);
                    if (allProducts.length >= 4) break;
                }
            }
            if(data.products.length < limit){ 
                moreProducts = false;
            }else{
                page++;
            }
        }

        return allProducts;
    }

    async function renderNewProducts(products){
        const promises = products.map(async product => {
            try{
                const response = await fetch(`/products/${product.handle}?section_id=card-product`);
                if(!response.ok) null;
                const html = await response.text();
                const li = document.createElement('li');
                li.innerHTML = html;
                return li;
            }catch{
                return null;
            }
        });
        const lis = await Promise.all(promises);
        lis.forEach(li => li && newProductsList.appendChild(li));
    }

    async function loadDiscountedProducts(){
        const allProducts = await fetchCollectionProducts(collection);
        if(allProducts.length === 0){
            newProductsSection.style.display = 'none';
            return;
        }
        newProductsSection.style.display = 'block';
        await renderNewProducts(allProducts);
    }

    loadDiscountedProducts();
});